/**
 * Bottom-left vitals (HP + armour) and bottom-right money + ammo.
 */
import { el, setNum, setText, setPct, setClass, setOpacity } from './dom.js';

export class Vitals {
  constructor(parent) {
    const root = el('div', 'cs-vitals', parent);
    this.root = root;

    const hp = el('div', 'cs-stat hp', root);
    el('i', 'cs-ico', hp, '+');
    this.hpVal = el('span', 'cs-val', hp, '100');
    const hpBar = el('div', 'cs-bar', hp);
    this.hpFill = el('i', null, hpBar);
    this.hp = hp;

    const ap = el('div', 'cs-stat armor', root);
    el('i', 'cs-ico', ap, 'S');
    this.apVal = el('span', 'cs-val', ap, '0');
    const apBar = el('div', 'cs-bar', ap);
    this.apFill = el('i', null, apBar);
    this.ap = ap;
  }

  update(s, now) {
    const hp = s?.hp ?? 0;
    setNum(this.hpVal, hp);
    setPct(this.hpFill, 'width', hp / 100);
    const low = hp > 0 && hp < 30;
    setClass(this.hp, 'low', low);
    setOpacity(this.hp, low ? 0.62 + 0.38 * (0.5 + 0.5 * Math.sin(now * 7)) : 1);

    const armor = s?.armor ?? 0;
    setNum(this.apVal, armor);
    setPct(this.apFill, 'width', armor / 100);
    setClass(this.ap, 'on', armor > 0);
  }
}

export class Cash {
  constructor(parent) {
    const root = el('div', 'cs-cash', parent);
    this.root = root;

    const money = el('div', 'cs-money', root);
    el('span', 'cs-cur', money, '$');
    this.amt = el('span', 'cs-amt', money, '0');

    const ammo = el('div', 'cs-ammo', root);
    this.ammoRow = ammo;
    this.mag = el('span', 'cs-mag', ammo, '0');
    el('span', 'cs-slash', ammo, '/');
    this.res = el('span', 'cs-res', ammo, '0');
    this.wname = el('span', 'cs-wname', ammo, '');
  }

  update(s) {
    setNum(this.amt, s?.money ?? 0);
    const ammo = s?.ammo ?? 0;
    setNum(this.mag, ammo);
    setNum(this.res, s?.reserve ?? 0);
    setText(this.wname, s?.weaponName ?? '');
    // A knife (magSize 0) has no meaningful ammo readout.
    const magSize = s?.magSize ?? 0;
    setClass(this.ammoRow, 'hidden', magSize <= 0);
    setClass(this.root, 'empty', magSize > 0 && ammo <= 0);
  }
}
